import { motion } from "framer-motion";
import { CheckCircle, Clock, Wifi } from "lucide-react";

export const OnlineCourse = () => {
  return (
    <div className="w-full bg-gray-50 min-h-screen">
      <div className="bg-secondary text-white py-20 px-4 text-center">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-bold mb-4"
        >
          Online Computational Thinking and Coding
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-xl max-w-2xl mx-auto opacity-90"
        >
          Course 2: Bringing Computational Thinking Home.
        </motion.p>
      </div>

      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                Online Computational Thinking and Coding Program
              </h2>
              <p className="text-xl text-gray-600 mb-8 font-medium">Bringing Computational Thinking Home</p>

              <div className="flex flex-wrap gap-6 mb-8 text-gray-600">
                <div className="flex items-center gap-2">
                  <Clock className="w-5 h-5 text-secondary" />
                  <span>6 months – 1 year (monthly enrolments available)</span>
                </div>
                <div className="flex items-center gap-2">
                  <Wifi className="w-5 h-5 text-secondary" />
                  <span>100% Online</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-secondary" />
                  <span>Age: 5-10 years</span>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed mb-6">
                We bring the digital version of our popular offline program — designed especially for students who can’t
                reach our learning centers. It includes all the features, activities, and hands-on experiences of our
                classroom sessions, reimagined for an engaging online environment.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Through live sessions, interactive challenges, and guided projects, children continue to explore coding,
                logic, and creativity from the comfort of their homes — developing the same computational thinking
                skills that define our in-person learning journey.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                For curriculum details, please refer to{" "}
                <a href="/courses/screen-free" className="text-secondary font-semibold hover:underline">
                  Screen-Free Computational Thinking and Coding
                </a>
                .
              </p>

              <h3 className="text-xl font-bold text-gray-800 mb-4">What Makes our program different</h3>
              <ul className="space-y-3">
                {[
                  "Beyond Coding: We focus on how to think, not just what to code.",
                  "Hands-On Learning: Kids create games, animations, and digital solutions while applying key computational skills.",
                  "Step-by-Step Progression: Four learning quarters take students from visual coding (Scratch) to real programming (Python).",
                  "Confidence Through Creation: Every project builds logic, persistence, and creativity.",
                  "100% Online: Flexible and mentor-led learning.",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-secondary shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="/images/medium-shot-boy-with-laptop_23-2148551604.jpg"
                  alt="Online coding class"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
